import React, { type FC } from 'react'
import TextSpecCondition from './TextSpecCondition'
import NumericSpecCondition from './NumericSpecCondition'
import DateSpecCondition from './DateSpecCondition'
import DateTimeSpecCondition from './DateTimeSpecCondition'
import { type UiFormat, UiTextFormat } from '../../filterConditionTypes'
import { isEnumMember } from '../../../../helpers/types'
import {
  DateFormat,
  DateTimeFormat,
  NumericFormat,
} from '../../../../types/FilterCondition'

interface ProfileFieldTypeFactoryProps {
  format: UiFormat
  blockIndex: number
  condIndex: number
}

const ProfileFieldTypeFactory: FC<ProfileFieldTypeFactoryProps> = ({
  format,
  blockIndex,
  condIndex,
}) => {
  if (isEnumMember<UiTextFormat>(format, UiTextFormat)) {
    return <TextSpecCondition blockIndex={blockIndex} condIndex={condIndex} />
  }
  if (isEnumMember<NumericFormat>(format, NumericFormat)) {
    return (
      <NumericSpecCondition blockIndex={blockIndex} condIndex={condIndex} />
    )
  }
  if (isEnumMember<DateFormat>(format, DateFormat)) {
    return <DateSpecCondition blockIndex={blockIndex} condIndex={condIndex} />
  }
  if (isEnumMember<DateTimeFormat>(format, DateTimeFormat)) {
    return (
      <DateTimeSpecCondition blockIndex={blockIndex} condIndex={condIndex} />
    )
  }
  return <></>
}
export default ProfileFieldTypeFactory
